import type { RouteRecordRaw } from "vue-router"
import OneComponentLayout from "@/app/layouts/OneComponentLayout.vue"
import ComingSoonView from "@/app/views/ComingSoonView.vue"
import GeoBlockedView from "@/app/views/GeoBlockedView.vue"
import MaintenanceView from "@/app/views/MaintenanceView.vue"

function getInitialRoute() {
  const modules = import.meta.env.VITE_APP_MODULES?.split(",")

  if (!modules?.length) {
    console.warn("No modules defined in VITE_APP_MODULES")
    return { name: "casino" }
  }

  return { name: modules?.[0] }
}

export const utilityRoutes: RouteRecordRaw = {
  path: "/",
  component: OneComponentLayout,
  children: [
    {
      path: "",
      name: "/",
      redirect: getInitialRoute(), // initialized in useConfig.ts
    },
    {
      path: "/maintenance",
      name: "maintenance",
      component: MaintenanceView,
    },
    {
      path: "/coming-soon",
      name: "coming-soon",
      component: ComingSoonView,
    },
    {
      path: "/geo-blocked",
      name: "geo-blocked",
      component: GeoBlockedView,
    },
  ],
}
